import React, { PropsWithChildren } from "react";

import { getCurrentSizeProfile } from "@common/components/Typography/style";
import { SxProps, Theme } from "@mui/material";
import Button, { UnionType as ButtonProps } from "@common/components/Button";

interface ActionBarButtonProps extends ButtonProps {
  label: string;
}

const ActionBarButton = ({
  label,
  sx,
  ...rest
}: ActionBarButtonProps): React.JSX.Element => {
  const buttonSx: SxProps<Theme> = (theme) => ({
    transitionDuration: `${theme.transitions.duration.short}ms`,
    transitionProperty: "border-color, width, min-width, color",
    transitionTimingFunction: theme.transitions.easing.easeInOut,
    "& > .MuiTypography-root": {
      transitionDuration: `${theme.transitions.duration.short}ms`,
      transitionProperty: "width, color",
      transitionTimingFunction: theme.transitions.easing.easeInOut,
    },
    "&.MuiButton-sizeMedium > .MuiButton-icon": { fontSize: getCurrentSizeProfile()["big"] },
    "&:not(.Mui-disabled)": {
      width: "fit-content",
      "& > .MuiTypography-root": {
        width: `${label.length * 0.55}em`,
      },
    },
    "&.Mui-disabled": {
      borderColor: "transparent",
      minWidth: 0,
      width: "1em",
      px: theme.spacing(2),
      py: theme.spacing(0.74),
      "& > .MuiTypography-root": {
        width: "0em",
        color: "transparent",
      },
      "& .MuiButton-startIcon": {
        margin: "0",
      },
    },
  });

  const sxArray = sx
    ? Array.isArray(sx)
      ? [...sx, buttonSx]
      : [sx, buttonSx]
    : [buttonSx];

  return (
    <Button sx={sxArray} {...rest} variant="outlined">
      {label}
    </Button>
  );
};

export default ActionBarButton;
